import React, {FC} from 'react';
import {observer} from "mobx-react";
import {Checkbox, Typography} from "@mui/material";
import {useStorageUserListContext} from "@app/modules/SelfConfig/contexts/storage";
import {Stack} from "@mui/system";
import {CheckboxBase} from "@app/components/CheckboxBase/CheckboxBase";


type TProps = {
}

export const CanSaveTranslation: FC<TProps> = observer((props: TProps) => {

    const {usersListStore} = useStorageUserListContext()

    const handleChange = () => {
        usersListStore.canSaveTranslation = !usersListStore.canSaveTranslation
    }

    return (
        <CheckboxBase
            description={"Permission to confirm translation"}
            disabled={usersListStore.mainLanguagesChosenIdSet.length == 0 || usersListStore.targetLanguagesChosenIdSet.length == 0}
            value={usersListStore.canSaveTranslation}
            checked={usersListStore.canSaveTranslation}
            onChange={() => handleChange()}
        />
    )

})

